import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { fRef } from '../../utils/React.js';
import { mainClass } from './MenulikeItem.styles.js';

var MenulikeItemPresentation = fRef(function (_ref) {
  var _cleanupClassObject;
  var role = _ref.role,
    _ref$hasTabIndex = _ref.hasTabIndex,
    hasTabIndex = _ref$hasTabIndex === void 0 ? true : _ref$hasTabIndex,
    highlight = _ref.highlight,
    selected = _ref.selected,
    disabled = _ref.disabled,
    id = _ref.id,
    onClick = _ref.onClick,
    onMouseOver = _ref.onMouseOver,
    ref = _ref.ref,
    children = _ref.children;
  return (
    /*#__PURE__*/
    /* key-events are handled by SelectWrapper */
    /* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
    React.createElement("div", {
      id: id,
      className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, "".concat(mainClass), true), _defineProperty(_cleanupClassObject, "".concat(mainClass, "__selected"), selected), _defineProperty(_cleanupClassObject, "".concat(mainClass, "__highlight"), highlight && !disabled), _defineProperty(_cleanupClassObject, "".concat(mainClass, "__disabled"), disabled), _cleanupClassObject)),
      onClick: !disabled && onClick ? onClick : function () {},
      onMouseMove: onMouseOver,
      ref: ref,
      /* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */
      tabIndex: hasTabIndex ? 0 : -1,
      role: role,
      "aria-selected": selected,
      "aria-disabled": disabled
    }, children)
  );
});
MenulikeItemPresentation.displayName = "MenulikeItemPresentation";

export { MenulikeItemPresentation };
